import { render, staticRenderFns } from "./CharacteristicItemName.vue?vue&type=template&id=bf94f9e0"
import script from "./CharacteristicItemName.vue?vue&type=script&lang=js"
export * from "./CharacteristicItemName.vue?vue&type=script&lang=js"
import style0 from "./CharacteristicItemName.vue?vue&type=style&index=0&id=bf94f9e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports